// @ai-generated 2026-08-27T12:28:10+00:00 by malte.ulfers@tngtech.com using Claude Opus 5
import { EnumAccessState } from './Generated';
import { type BadgeVariations } from '@synqo/frontend-component-library';

export const getEnumAccessStateLabel = (value: EnumAccessState) => {
    switch (value) {
        case EnumAccessState.Unlocked:
            return 'Aktiv';
        case EnumAccessState.Locked:
            return 'Gesperrt';
        default:
            return 'Nicht definiert';
    }
};

export const getBadgeVariantByAccessState = (value: EnumAccessState): BadgeVariations => {
    switch (value) {
        case EnumAccessState.Unlocked:
            return 'success';
        case EnumAccessState.Locked:
            return 'warning';
        default:
            return 'danger';
    }
};
